import React, { useEffect, useRef, useCallback, useMemo, useState, useImperativeHandle, forwardRef } from 'react';

import { Popup } from 'devextreme-react/popup';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import { Button } from 'devextreme-react/button';
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';
import { LoadIndicator } from 'devextreme-react/load-indicator';
import Box, { Item as BoxItem } from 'devextreme-react/box';
import './index.scss';

import AntErrorPanel from '../AntErrorPanel';
import AntDescPanel from '../AntDescPanel';
import AntAPI from '../../utils/AntAPI';
import AntLocalization from '../../utils/AntLocalization';

export default forwardRef(function (props, ref) {
    const [visible, setVisible] = useState(false);
    const [title, setTitle] = useState(AntLocalization.translateText({ vi: 'Xác nhận', en: 'Confirmation', fr: 'Confirmation', es: 'Confirmación', id: 'Konfirmasi', ja: '確認', zh: '确认', ko: '확인', hi: 'पुष्टि', ar: 'تأكيد' }));
    const [content, setContent] = useState('');
    const [cancelText, setCancelText] = useState(AntLocalization.translateText({ vi: 'Bỏ qua', en: 'Cancel', fr: 'Annuler', es: 'Cancelar', id: 'Batal', ja: 'キャンセル', zh: '取消', ko: '취소', hi: 'रद्द करें', ar: 'إلغاء' }));
    const [cancelIcon, setCancelIcon] = useState('');
    const [errorText, setErrorText] = useState(null);
    const [passCode, setPassCode] = useState(null);

    const [token, setToken] = useState(null);
    const [message, setMessage] = useState('');
    const [processing, setProcessing] = useState(false);
    const [onClosedCallback, setOnClosedCallback] = useState(false);

    const refPassCode = useRef();
    const API = useMemo(() => new AntAPI('sys', 'Business', []));

    const close = useCallback(
        async (button) => {
            if (onClosedCallback) await onClosedCallback(button);
            setVisible(false, () => {
                if (props.onClosed) props.onClosed(button);
            });
        },
        [onClosedCallback, props.onClosed]
    );

    const show = useCallback(
        async (args, onClosedCallback) => {
            var title = args.title;
            var content = args.content;
            var cancelText = args.cancelText;
            var cancelIcon = args.cancelIcon;

            setVisible(true);
            setProcessing(false);
            setTitle(title);
            setToken(null);
            setPassCode('');
            setErrorText(null);
            setContent(content);
            setCancelText(cancelText);
            setCancelIcon(cancelIcon);
            setOnClosedCallback(onClosedCallback);

            var res = await API.postConfirmOTPRequest(
                props.formData ? props.formData.code : null,
                props.formData ? props.formData.id : null,
                props.actionName,
                props.params
            );
            if (res && res.error) setErrorText(res.error);

            if (res && res.data && res.data.sent) setToken(res.data.token);
            if (res && res.data && res.data.message) setMessage(res.data.message);

            if (props.onShowed) props.onShowed();
        },
        [props.formData, props.actionName, props.params, props.onShowed]
    );

    const onPassCodeChanged = useCallback((e) => {
        setErrorText(null);
        setPassCode(e.value);
    }, []);

    const onPassCodeValidated = useCallback(
        async (_passCode) => {
            setErrorText(null);
            setProcessing(true);

            var res = await API.postConfirmOTPVerify(
                props.formData ? props.formData.code : null,
                props.formData ? props.formData.id : null,
                props.actionName,
                token,
                _passCode
            );

            if (res && res.error) {
                setErrorText(res.error);
            }
            setProcessing(false);

            if (res && res.data && res.data.valid_otp && res.data.succeed) {
                if (props.onSucceed) props.onSucceed();
                close();
            }
        },
        [props.onSucceed, close, token]
    );

    useEffect(() => {
        if (String(passCode).trim().length === 6) onPassCodeValidated(passCode);
    }, [passCode]);

    // var strContent = this.props.content ? this.props.content : this.state.content;

    useImperativeHandle(ref, () => ({
        show: show
    }));

    return (
        <Popup
            wrapperAttr={{
                class: 'ant-popup'
            }}
            visible={visible}
            onHiding={close}
            onShown={() => {
                if (refPassCode.current && refPassCode.current.instance) refPassCode.current.instance.focus();
            }}
            dragEnabled={false}
            hideOnOutsideClick={false}
            resizeEnabled={true}
            showTitle={true}
            defaultHeight={props.height ? props.height : 'auto'}
            defaultWidth={props.width ? props.width : 500}
            title={props.title ? props.title : title}
            position={'center'}
            animation={{
                show: {
                    type: 'fadeIn',
                    duration: 600,
                    from: {
                        scale: 0.55
                    }
                },
                hide: {
                    type: 'fadeOut',
                    duration: 600,
                    to: {
                        opacity: 0,
                        scale: 0.55
                    },
                    from: {
                        opacity: 1,
                        scale: 1
                    }
                }
            }}
        >
            <Box direction="col" height="100%" width="100%">
                <BoxItem ratio={1}>
                    <span
                        style={{
                            marginLeft: props.marginLeft ? props.marginLeft : 10,
                            marginRight: props.marginRight ? props.marginRight : 10,
                            marginTop: props.marginTop ? props.marginTop : 10,
                            fontSize: props.fontSize ? props.fontSize : 'larger'
                        }}
                    >
                        <div style={{ display: processing ? 'none' : 'block' }}>
                            {/* {strContent && (
                                        <div className={'dx-field'}>
                                            <AntDescPanel text={strContent} />
                                        </div>
                                    )} */}

                            {!message && (
                                <div className={'dx-field'}>
                                    <AntDescPanel
                                        text={{ vi: 'Mã xác nhận đã được gửi đến số điện thoại quản trị.', en: 'A verification code was sent to the admin phone number.', fr: 'Le code de vérification a été envoyé au téléphone de l\'administrateur.', es: 'El código de verificación se envió al teléfono del administrador.', id: 'Kode verifikasi telah dikirim ke nomor telepon admin.', ja: '確認コードを管理者の電話番号に送信しました。', zh: '验证码已发送至管理员手机号。', ko: '인증 코드가 관리자 전화번호로 전송되었습니다.', hi: 'सत्यापन कोड व्यवस्थापक के फ़ोन नंबर पर भेजा गया है।', ar: 'تم إرسال رمز التحقق إلى رقم هاتف المسؤول.' }}
                                    />
                                    <AntDescPanel
                                        text={{ vi: 'Vui lòng kiểm tra tin nhắn và nhập lại :', en: 'Please check your SMS and enter the code:', fr: 'Vérifiez vos SMS et saisissez le code :', es: 'Revise sus SMS e introduzca el código:', id: 'Periksa SMS Anda dan masukkan kodenya:', ja: 'SMSを確認してコードを入力してください：', zh: '请查看短信并输入验证码：', ko: 'SMS를 확인하고 코드를 입력하세요:', hi: 'कृपया SMS देखें और कोड दर्ज करें:', ar: 'يرجى مراجعة الرسائل وإدخال الرمز:' }}
                                    />
                                </div>
                            )}
                            {message && (
                                <div className={'dx-field'}>
                                    <AntDescPanel text={message} />
                                </div>
                            )}

                            <div className={'dx-field'}>
                                <TextBox
                                    ref={refPassCode}
                                    value={passCode}
                                    placeholder={'OTP'}
                                    width={'100%'}
                                    className={'confirm-box-owner-phone-otp'}
                                    mask="0 0 0 0 0 0"
                                    maskRules={{ X: /[02-9]/ }}
                                    maskInvalidMessage={null}
                                    // validationStatus="valid"
                                    valueChangeEvent="keyup"
                                    onValueChanged={onPassCodeChanged}
                                    onFocusIn={(e) => {
                                        let inputEl = e.element.querySelector('.dx-texteditor-input');
                                        if (inputEl) {
                                            inputEl.selectionStart = 0;
                                            inputEl.selectionEnd = inputEl.value.length;
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div style={{ display: !processing ? 'none' : 'block' }}>
                            <div className={'dx-field'} style={{ textAlign: 'center' }}>
                                <LoadIndicator className={'confirm-box-loading'} />
                            </div>
                            <div className={'dx-field'} style={{ textAlign: 'center' }}>
                                <AntDescPanel text={{ vi: 'Đang xử lý . . .', en: 'Processing . . .', fr: 'Traitement . . .', es: 'Procesando . . .', id: 'Memproses . . .', ja: '処理中 . . .', zh: '处理中 . . .', ko: '처리 중 . . .', hi: 'प्रक्रिया जारी . . .', ar: 'جارٍ المعالجة . . .' }} />
                            </div>
                        </div>
                    </span>
                </BoxItem>
                <BoxItem baseSize={50}>
                    <div className={'dx-field'} style={{ marginLeft: '-18px' }}>
                        <AntErrorPanel text={errorText} />
                    </div>
                </BoxItem>
            </Box>
        </Popup>
    );
});
